import { API_ROUTE } from "./../utils/api-domain";
import axios from "axios";

export const getUser = async (userId: string, accessToken: string) => {
  const response = await axios.get(`${API_ROUTE}user/${userId}`, {
    headers: {
      "x-auth-token": accessToken,
    },
  });

  console.log("response ti get user", response.data);

  return response.data;
};

export const getOrg = async (orgId: string, accessToken: string) => {
  const response = await axios.get(`${API_ROUTE}org/${orgId}`, {
    headers: {
      "x-auth-token": accessToken,
    },
  });

  return response.data;
};
